import * as types from "../types/userTypes";
import * as userServices from "../../services/userServices";

export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: types.FETCH_USERS_REQUEST });
  try {
    const data = await userServices.fetchUsers();
    dispatch({ type: types.FETCH_USERS_SUCCESS, payload: Array.isArray(data) ? data : [] });
  } catch (error) {
    dispatch({ type: types.FETCH_USERS_FAILURE, payload: error.message });
  }
};

export const fetchUserStats = () => async (dispatch) => {
  dispatch({ type: types.FETCH_USER_STATS_REQUEST });
  try {
    const data = await userServices.fetchUserStats();
    dispatch({ type: types.FETCH_USER_STATS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_USER_STATS_FAILURE, payload: error.message });
  }
};

export const createUser = (payload) => async (dispatch) => {
  dispatch({ type: types.CREATE_USER_REQUEST });
  try {
    const data = await userServices.createUser(payload);
    dispatch({ type: types.CREATE_USER_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    dispatch({ type: types.CREATE_USER_FAILURE, payload: error.message });
    return { success: false, error: error.message };
  }
};

export const updateUser = (id, payload) => async (dispatch) => {
  dispatch({ type: types.UPDATE_USER_REQUEST });
  try {
    const data = await userServices.updateUser(id, payload);
    dispatch({ type: types.UPDATE_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.UPDATE_USER_FAILURE, payload: error.message });
  }
};

export const deleteUser = (id) => async (dispatch) => {
  dispatch({ type: types.DELETE_USER_REQUEST });
  try {
    await userServices.deleteUser(id);
    dispatch({ type: types.DELETE_USER_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: types.DELETE_USER_FAILURE, payload: error.message });
  }
};
